import { gql, useMutation } from '@apollo/client';
import { callSideEffects } from '../../util';
import { GET_SHORTLIST } from './useShortlist';
const CLEAR_SHORTLIST_MUTATION = gql `
    mutation ClearShortlist {
        clearShortlist {
            success
            estabIds
        }
    }
`;
export function useClearShortlist(sideEffects) {
    return useMutation(CLEAR_SHORTLIST_MUTATION, {
        onCompleted: (removeData) => {
            callSideEffects(sideEffects, removeData);
        },
        refetchQueries: [GET_SHORTLIST, 'getShortlist'],
    });
}
